export const testimonials = [
  {
    id: 1,
    name: "Luis García",
    service: "Reparación de Chapa y Pintura",
    quote: "Mi coche quedó como nuevo después del siniestro. Trabajo impecable, mejor de lo que esperaba. La garantía de por vida me da mucha tranquilidad.",
    rating: 5,
    location: "Sevilla"
  },
  {
    id: 2,
    name: "María Rodríguez",
    service: "Mantenimiento y Revisión",
    quote: "Muy profesionales y rápidos. Siempre vuelvo para las revisiones de mi coche. Me avisaron de todo antes de hacer cualquier trabajo.",
    rating: 5,
    location: "Mairena del Aljarafe"
  },
  {
    id: 3,
    name: "Carlos Martín",
    service: "Mecánica - Cambio de Embrague",
    quote: "Excelente atención y precio muy competitivo. Me explicaron todo el proceso y el plazo lo cumplieron perfectamente. Muy recomendable.",
    rating: 5,
    location: "Bormujos"
  },
  {
    id: 4,
    name: "Ana López",
    service: "Gestión con Aseguradora",
    quote: "Se encargaron de todo con mi aseguradora. No tuve que preocuparme de nada. El coche de cortesía fue un detalle genial mientras reparaban el mío.",
    rating: 5,
    location: "Tomares"
  },
  {
    id: 5,
    name: "Javier Fernández",
    service: "Reparación de Siniestro",
    quote: "Tenía golpes en varias partes del coche y quedó perfecto. Han igualado el color a la perfección, no se nota para nada dónde estaban los golpes.",
    rating: 5,
    location: "Sevilla"
  }
];
